import {
  decorateVideoTypesForAspectRatio,
  DestinationPlatform,
  getDisabledPlatformsForAspectRatio,
  PLATFORM_DISPLAY_NAMES,
  PlatformConfig,
} from 'blocks/DestinationPlatforms';
import { AspectRatioName } from 'types';
import bem from 'utils/bem';
import { MINUTE_IN_SECONDS, secToMillis } from 'utils/time';
import { VideoWizardObjective } from '../types';

export const block = bem('video-wizard-destination-step');

const buildPlatformMismatchTooltip = (platform: DestinationPlatform) =>
  `${PLATFORM_DISPLAY_NAMES[platform]} doesn't have a format that fits your template`;

const SUB_PLATFORM_MISMATCH_TOOLTIP = "This format doesn't fit your template";

export function getDisabledPlatforms(requiredAspectRatio?: AspectRatioName) {
  if (!requiredAspectRatio) {
    return undefined;
  }

  return getDisabledPlatformsForAspectRatio(
    'videoTranscript',
    requiredAspectRatio,
    buildPlatformMismatchTooltip,
  );
}

export function getDestinationVideoTypes(
  platformConfig: PlatformConfig,
  objective: VideoWizardObjective,
  requiredAspectRatio: AspectRatioName,
  platform: DestinationPlatform,
) {
  const durationFiltered = platformConfig?.videoTypes.filter(
    videoType =>
      // Filtering out all 10 min video types in the MultipleClips flow.
      !(
        objective === 'MultipleClips' &&
        videoType.durationMs >= secToMillis(MINUTE_IN_SECONDS * 10)
      ),
  );

  if (!durationFiltered || !requiredAspectRatio || !platform) {
    return durationFiltered;
  }

  return decorateVideoTypesForAspectRatio(
    durationFiltered,
    platform,
    'videoTranscript',
    requiredAspectRatio,
    SUB_PLATFORM_MISMATCH_TOOLTIP,
  );
}
